import React, { useState, useEffect } from "react";

import Map from "./map";
import Search from "../../search/view/Search";
import { webButton, podText, webText, podWebImage } from "./webButton.module.css"
import {ReactComponent as PodWeb} from "../../../assets/PodWeb.svg";

import Callout from "./callout"; 

// The idea here is to hold both the search and the map
// The search passes state around in this component with the search tags
// The map receives this from props and uses it in the fetch users / clusters functions

export default () => {
    const [searchOptions, setSearchOptions] = useState({})
    const [activeUser, setActiveUser] = useState({
        name: "", 
        tags: [],
        imageURL: "",
        createdAt: "",
        profileId: "",
        tagFeatured: ""          
    })
    const [portraitOrientation, setPortraitOrientation] = useState(false)

    const onUserTap = user => {
        setActiveUser(user)
    }

    useEffect(() => {
        function handleResize() {
            if (window.innerWidth < 768) {
                setPortraitOrientation(true)
            } else {
                setPortraitOrientation(false)
            }
        }
        handleResize()
        window.addEventListener('resize', handleResize)
    })

    return (
        <>
        <div>
            <Map
                style={{
                    position: "relative",
                    zIndex: 1
                }}
                googleMapKey="AIzaSyAXRZxTG8Bp4eBEdWO4Iv_bcem35_NllL4"
                searchOptions={searchOptions}
                updateCallout={onUserTap}
            />
        </div>
        <Search submit={setSearchOptions} />
        {/* Web Button
        <a href="http://web.pod.io">           
            <div
                className={webButton}
                style={{bottom: portraitOrientation 
                    ? activeUser.name ? "28vh" : "2vh"
                    : "2vh"
                    , right: "2vw",}}
            >
                <PodWeb className={podWebImage} />
                <span className={podText}>Pod</span>
                <span className={webText}>Web</span>
            </div> 
        </a> */}
        {
            activeUser.name !== "" 
            ? <Callout name={activeUser.name} tags={activeUser.tags} imageURL={activeUser.imageURL} createdAt={activeUser.createdAt} profileId={activeUser.profileId} tagFeatured={activeUser.tagFeatured} />
            : null
        }
                   
        </>
    )
}